import { createContext } from 'react';
import _noop from 'lodash/noop';

export const UploadAudioFilesContext =
    createContext<UploadAudioFilesProviderValue>({
        handleFiles: _noop,
        hasActiveAudioUploads: false,
        uploadTasks: [],
        uploadResults: [],
    });
